import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { PendingDriverAssignmentsService } from 'app/modules/vehicle-inventory/services/pending-driver-assignments.service';
import { DriverService } from 'app/modules/vehicle-inventory/services/driver.service';
import { Rest } from 'app/rest/rest_client';
import { I18nService } from 'app/services/i18n/i18n.service';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';

@Component({
    selector: 'app-pending-driver-assignments-form',
    templateUrl: './pending-driver-assignments-form.component.html',
    styleUrls: ['./pending-driver-assignments-form.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PendingDriverAssignmentsFormComponent extends EntityFormComponent<Rest.InvPendingDriverAssignment>
implements OnInit {

    title: string;

    driverList: Rest.InvDriver[] = [];
    driverRequestContext: any;
    startDate: Date;
    endDate: Date;
    kms: number;

    canUpdate: boolean;

    ids: number[] = [];

    constructor(
        private pendingDriverAssignmentsService: PendingDriverAssignmentsService,
        notificationsService: NotificationsService,
        protected i18n: I18nService,
        protected authenticationService: AuthenticationService,
        public translateService: TranslateService,
        private driverService: DriverService,
        protected userTime: UserTimePipe,
    ) {
        super(pendingDriverAssignmentsService, notificationsService, i18n, authenticationService);
    }

    ngOnInit(): void {
        this.setPermissions();
    }

    setPermissions() {
        const user = this.authenticationService.user;
        this.canUpdate = this.authenticationService.isRoleGranted('INV_DRIVER_ASSIGNMENTS_UPDATE', user);
    }

    beforeShow() {
        this.title = this.translateService.instant('drivers.table.drivers');

        this.ids = [];
        if (this.entity.documents && this.entity.documents.length > 0) {
            this.entity.documents.forEach(x => this.ids.push(x.id));
        } else {
            this.ids = [-1];
        }

        this.driverRequestContext = {
            sortBy: 'employee.code',
            sortAsc: true,
            pageSize: 10,
            loadPermissions: false,
            filters: {},
        } as Rest.ListPaginationRequest;

        if (this.entity.driver) {
            this.driverRequestContext.filters['user'] = [this.entity.driver.employee.code];
        }

        this.driverService.getPage(this.driverRequestContext).then((p) => {
            this.driverList = p.entities.map((driver) => ({
                ...driver,
                fullName: `(${driver.employee.code}) ${driver.employee.user.surname1} ${driver.employee.user.surname2}, ${driver.employee.user.name}`,
            }));
        });

        this.startDate = this.entity.startDate ? this.userTime.utcToCalendarDate(this.entity.startDate) : null;
        this.endDate = this.entity.endDate ? this.userTime.utcToCalendarDate(this.entity.endDate) : null;
        this.kms = this.entity.kms;
    }

    onFilterDriver(event) {
        this.driverRequestContext.filters['user'] = [event.filter ?? ''];
        this.driverService.getPage(this.driverRequestContext).then((p) => {
            this.driverList = p.entities.map((driver) => ({
                ...driver,
                fullName: `(${driver.employee.code}) ${driver.employee.user.surname1} ${driver.employee.user.surname2}, ${driver.employee.user.name}`,
            }));
        });
    }

    onChangeDriver(event) {
        this.entity.driver = event.value;
    }

    refresh() {
        this.return.emit();
    }

    protected beforeSave(): void {
        this.entity.startDate = this.startDate;
        this.entity.endDate = this.endDate;
        this.entity.kms = this.kms;

        if (this.entity.driver) {
            delete this.entity.driver['fullName'];
            this.entity.driver.licenseData = null;
        }
    }

}
